import * as dates from "../../../reducers/changeTimePeriod";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";
import { IEventViewProps } from "../EventView";

export function initialiseDaysCellsForThisMonth(monthStartDate: Date, monthEndDate: Date): IDayCell_MonthMobile[] {
  // Pre-populate array of dayCells for days of month with date and day number of week for each dayCell.

  const totalDaysInMonth = dates.getDaysBetweenDates(monthStartDate, monthEndDate);

  const dayCells: IDayCell_MonthMobile[] = new Array(totalDaysInMonth);

  let dayCellDate = monthStartDate;
  for (let cellNumber = 0; cellNumber < totalDaysInMonth + 1; cellNumber++) {
    // Set default data for this day's dayCell:
    const thisDayCell: IDayCell_MonthMobile = {
      cellNumber,
      date: dayCellDate,
      slots: [],
      totalNumberEvents: 0,
    };
    dayCells[cellNumber] = thisDayCell;

    // Advance to the next day:
    dayCellDate = dates.addDays(dayCellDate, 1);
  }

  return dayCells;
}

export function transformListOfEventsIntoArrayOfDayCellsForMonth_Mobile(props: IEventViewProps): IDayCell_MonthMobile[] {

  // Create an array of dayCells (one per day of displayed month), and add an empty dayCell to each cell in array.
  const dayCells: IDayCell_MonthMobile[] = initialiseDaysCellsForThisMonth(props.localFromDate, props.localToDate);

  // Loop through the events and assign them to the dayCells:
  for (const event of props.events) {

    // Add the event to every day in the month that it is in.

    // If the event starts before the displayed month, have to set start date to first day of month.
    let firstVisibleDateOfEvent = event.localStartDate;
    if (dates.isBefore(firstVisibleDateOfEvent, props.localFromDate) && dates.isAfter(event.localEndDate, props.localFromDate)) {
      firstVisibleDateOfEvent = props.localFromDate;
    }

    // If the event extends after the displayed month, have to set end date to last day of month.
    let lastVisibleDateOfEvent = event.localEndDate;
    if (dates.isAfter(lastVisibleDateOfEvent, props.localToDate) && dates.isBefore(event.localStartDate, props.localToDate)) {
      lastVisibleDateOfEvent = props.localToDate;
    }

    // Add the event to each dayCell that it is in.
    const eventsDayCells = dayCells.filter((thisDayCell) => dates.isSameDayOrAfter(thisDayCell.date, firstVisibleDateOfEvent) && dates.isSameDayOrBefore(thisDayCell.date, lastVisibleDateOfEvent));

    if (eventsDayCells) {

      for (const eventsDayCell of eventsDayCells) {

        // Create the new dayCellSlot object.
        const firstAvailableDaySlotNumber = eventsDayCell.slots.length;

        const dayCellSlot: IDayCellSlot_MonthMobile = {
          event,
          slotNumber: firstAvailableDaySlotNumber,
        };

        // Add dayCellSlot to the topmost upoccupied slot in the dayCell.
        eventsDayCell.slots[firstAvailableDaySlotNumber] = dayCellSlot;
        eventsDayCell.totalNumberEvents++;
      }

    }

  }

  return dayCells;
}
